import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Button,
  Loader,
  Icon,
  Modal
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { userActions } from '../../actions/user.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';
import { getAuthActionLabel, getAuthProviderLabel, getRoleLabel, getWorkStatusLabel } from '../../helpers/user';
import { DateTimeInput } from 'semantic-ui-calendar-react-17';
import { getStatusLabel } from '../../helpers/request';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class AuditUserScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        page: 1,
        search: '',
    };
  }

  static get propTypes() {
    return {
       registers: PropTypes.any,
       loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}`}, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
      this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, search } = this.state;
    dispatch(userActions.fetch({ page, search, orderBy: "Name", export: isExport ? true : null, ascending: true }));
  }

  handleChange(field, data) {    
    const state = this.state;    
    state[field] = data;    
    state.page = 1;
    this.setState(state);    
    this.handleSearchDebounced();
  }

  handleSubmit() {
    const { dispatch } = this.props;
    const { request } = this.state;
    let payload = {
      username: request.username,
      date: moment(request.date, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
    };

    dispatch(reportActions.create(payload)).then(() => {
      this.fetchRegisters()
    });    
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;    

    return (
      <Fragment>
        <Header>
          <h1>Auditoria Usuários</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <Form.Input icon='search' label='Username ou Nome' onChange={(e, data) => this.handleChange("search", data.value)} loading={loading} />            
            
            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'>
              <Icon name='file excel' /> Exportar
            </Form.Button>            
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
                <Table.Row>                                      
                    <Table.HeaderCell>Perfil</Table.HeaderCell>                      
                    <Table.HeaderCell>Usuário</Table.HeaderCell>                    
                    <Table.HeaderCell>Username</Table.HeaderCell>
                    <Table.HeaderCell>E-Mail</Table.HeaderCell>                                  
                    <Table.HeaderCell>Status</Table.HeaderCell>                    
                    <Table.HeaderCell>Criado em</Table.HeaderCell>
                    <Table.HeaderCell>Alterado em</Table.HeaderCell>                    
                </Table.Row>
            </Table.Header>
            <Table.Body>              
                { registers && registers.Results && registers.Results.map((register) => {
                    return <Table.Row key={register.Id}>                 
                        <Table.Cell>{getRoleLabel(register.Role)}</Table.Cell>    
                        <Table.Cell>{register.Name}</Table.Cell>                           
                        <Table.Cell>{register.Username}</Table.Cell>              
                        <Table.Cell>{register.Email}</Table.Cell>               
                        <Table.Cell>{register.Active ? 'Ativo' : 'Inativo'}</Table.Cell>               
                        <Table.Cell>{register.CreatedAt ? moment(register.CreatedAt).format('DD/MM/YYYY HH:mm') : '-'}</Table.Cell>               
                        <Table.Cell>{register.UpdatedAt ? moment(register.UpdatedAt).format('DD/MM/YYYY HH:mm') : '-'}</Table.Cell>
                    </Table.Row>;
                }) }
            </Table.Body>
        </Table>}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users } = state;  

  
  return {
    registers: users || null,
    loading: users?.loading
  };
}

const connectedAuditUserScreen = connect(mapStateToProps)(AuditUserScreen);
export { connectedAuditUserScreen as AuditUserScreen };
